import { render, staticRenderFns } from "./ArtificialPaper.vue?vue&type=template&id=111da5bc&scoped=true"
import script from "./ArtificialPaper.vue?vue&type=script&lang=js"
export * from "./ArtificialPaper.vue?vue&type=script&lang=js"
import style0 from "./ArtificialPaper.vue?vue&type=style&index=0&id=111da5bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111da5bc",
  null
  
)

export default component.exports